module.exports = __webpack_public_path__ + "img/thumb-002-01.17fa3610.png";